function insertBannerPlaceholder(htmlContent: string, placeholderName: string): string {
  const container = window.document.createElement('div')
  container.innerHTML = htmlContent

  const paragraphs = Array.from(container.querySelectorAll('p')) as HTMLParagraphElement[]
  if (paragraphs.length < 1) return htmlContent

  const target = getTargetParagraph(paragraphs)
  if (!target) return htmlContent

  if (target) {
    const placeholder = window.document.createElement('div')
    placeholder.setAttribute(placeholderName, 'true')

    target.parentNode?.insertBefore(placeholder, target.nextSibling)
  }

  return container.innerHTML
}

function getTargetParagraph(paragraphs: HTMLParagraphElement[]): HTMLParagraphElement | null {
  // Obtém o comprimento "efetivo" de cada parágrafo (ignora tags e normaliza espaços)
  const lens = paragraphs.map((p) => {
    const text = (p.textContent || '').replace(/\s+/g, ' ').trim()
    return text.length
  })

  const total = lens.reduce((a, b) => a + b, 0)
  if (total === 0) return null

  const midpoint = total / 2

  // Localiza a quebra mais próxima do meio
  const prefix: number[] = []
  lens.reduce((acc, v, i) => {
    const curr = acc + v
    prefix[i] = curr
    return curr
  }, 0)

  // Encontra o primeiro índice cujo acúmulo ultrapassa o meio
  let idx = prefix.findIndex((v) => v >= midpoint)
  if (idx === -1) idx = paragraphs.length - 1

  // Decide se insere após o parágrafo anterior ou o atual (o mais próximo do meio)
  const prevCum = idx > 0 ? prefix[idx - 1] : 0
  const currCum = prefix[idx]
  const insertAfterIndex =
    Math.abs(prevCum - midpoint) <= Math.abs(currCum - midpoint) ? idx - 1 : idx

  const targetParagraph = paragraphs[insertAfterIndex]

  if (!targetParagraph || !targetParagraph.parentNode) return null

  return targetParagraph
}

function hadleBannerSpacing(bannerHost: HTMLElement) {
  const prevElement = bannerHost.previousElementSibling as HTMLElement | null
  const nextElement = bannerHost.nextElementSibling as HTMLElement | null

  if (prevElement && nextElement) {
    const prevElMarginBottom = parseFloat(window.getComputedStyle(prevElement).marginBottom)
    const nextElMarginTop = parseFloat(window.getComputedStyle(nextElement).marginTop)

    if (prevElMarginBottom && !nextElMarginTop) {
      bannerHost.style.marginBottom = `${prevElMarginBottom}px`
    } else if (!prevElMarginBottom && nextElMarginTop) {
      bannerHost.style.marginTop = `${nextElMarginTop}px`
    } else if (!prevElMarginBottom && !nextElMarginTop) {
      bannerHost.style.marginTop = '16px'
      bannerHost.style.marginBottom = '16px'
    }
  }
}

function parseBannerPlaceholder(documentText: string, placeholderName: string): string {
  const tempDiv = window.document.createElement('div')
  tempDiv.innerHTML = documentText
  const paragraphs = tempDiv.querySelectorAll('p')

  let textWithBannerPlaceholder = documentText

  if (paragraphs.length > 1) {
    textWithBannerPlaceholder = insertBannerPlaceholder(documentText, placeholderName)
  }

  return textWithBannerPlaceholder
}

function isYouTubeUrl(url: string): boolean {
  try {
    const urlObj = new URL(url)
    return urlObj.hostname.includes('youtube.com') || urlObj.hostname.includes('youtu.be')
  } catch {
    return false
  }
}

function parseVideos(
  documentText: string,
  wrapperVideoClassName: string,
  videoClassName: string,
  overlayClassName?: string
): string {
  const videosTempDiv = window.document.createElement('div')
  videosTempDiv.innerHTML = documentText

  const videos = [].slice.call(videosTempDiv.querySelectorAll('[data-media="embed-video"]'), 0)

  videos.forEach((video: HTMLAnchorElement, index: number) => {
    const src = video.getAttribute('href') || ''
    const wrapper = window.document.createElement('div')
    wrapper.className = wrapperVideoClassName
    wrapper.setAttribute('data-video-embed', 'true')
    wrapper.setAttribute('data-video-src', src)

    const isYouTube = isYouTubeUrl(src)
    const useYouTubeAPI = isYouTube && overlayClassName
    const playerId = useYouTubeAPI
      ? `youtube-player-${index}-${Math.random().toString(36).substr(2, 9)}`
      : undefined

    if (playerId) {
      wrapper.setAttribute('data-youtube-player-id', playerId)
      const playerDiv = window.document.createElement('div')
      playerDiv.id = playerId
      playerDiv.className = videoClassName
      wrapper.appendChild(playerDiv)
    } else {
      const iframe = window.document.createElement('iframe')
      iframe.className = videoClassName
      iframe.src = src
      wrapper.appendChild(iframe)
    }

    if (overlayClassName && !isYouTube) {
      const overlay = window.document.createElement('div')
      overlay.className = overlayClassName
      overlay.setAttribute('data-video-overlay', 'true')
      wrapper.appendChild(overlay)
    }

    video.parentNode?.replaceChild(wrapper, video)
  })

  return videosTempDiv.innerHTML
}

export { hadleBannerSpacing, insertBannerPlaceholder, parseBannerPlaceholder, parseVideos }
